// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyV1PharmacyBiRequestSearchDefaultResponse {
    static getAttributeTypeMap() {
        return PharmacyV1PharmacyBiRequestSearchDefaultResponse.attributeTypeMap;
    }
}
PharmacyV1PharmacyBiRequestSearchDefaultResponse.discriminator = undefined;
PharmacyV1PharmacyBiRequestSearchDefaultResponse.additionalProperties = false;
PharmacyV1PharmacyBiRequestSearchDefaultResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "PharmacyV1PharmacyBiRequestSearchDefaultResponseData"
    },
];
//# sourceMappingURL=pharmacyV1PharmacyBiRequestSearchDefaultResponse.js.map